import { Link } from "@/components/Link";
import { routeFactory } from "@/RouteFactory";
import { formatCustomerIndexLabel } from "@/lib/formatters/CustomerIndexFormatter";
import { Indent, Text } from "@stenajs-webui/core";
import { Tooltip } from "@stenajs-webui/tooltip";
import React from "react";

interface Props {
  customerNo: number | undefined;
  customerIndex: string | undefined;
  tooltipLabel?: string;
  width?: string;
}

export const RoutePairCustomerLinkCell: React.FC<Props> = ({
  customerNo,
  customerIndex,
  tooltipLabel,
  width,
}) => {
  if (customerNo === undefined) {
    return (
      <Indent>
        <Text>-</Text>
      </Indent>
    );
  }

  const content = (
    <div
      style={{
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        overflow: "hidden",
        width,
      }}
    >
      <Link
        to={routeFactory.productAndPrice.customer.customer({
          customerId: String(customerNo),
        })}
      >
        {formatCustomerIndexLabel(customerNo, customerIndex)}
      </Link>
    </div>
  );

  return (
    <Indent>
      {tooltipLabel ? (
        <Tooltip label={tooltipLabel} appendTo={document.body}>
          {content}
        </Tooltip>
      ) : (
        content
      )}
    </Indent>
  );
};
